import * as R from 'ramda';

export function getStringOffsetByTitle(title: string) {
  if (title.length > 6) {
    const coefficient = title.length <= 12 ? 0.5 : 0.35;
    return R.repeat('x', Math.round(title.length * coefficient)).join();
  }
  return '';
}
